import { Box, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const LocalitiesCell = ({ localities }) => {
  const theme = useTheme()
  const { t: translate } = useTranslation(['maintenance', 'common'])

  if (!localities.length) return null

  return (
    <Box>
      {localities.length > 1 ? (
        <Box
          sx={{
            position: 'relative',
            '&:hover .localities-list': {
              display: 'block',
            },
            backgroundColor: theme.palette.primaryMain[theme.palette.mode],
            color: theme.palette.white[theme.palette.mode],
            padding: '4px 8px',
            borderRadius: '4px',
          }}
        >
          <Typography variant="body2">{`${localities.length} ${translate('localities', { ns: 'common' })}`}</Typography>
          <Box
            className="localities-list"
            sx={{
              display: 'none',
              position: 'fixed',
              backgroundColor: theme.palette.background.paper,
              boxShadow: theme.shadows[3],
              padding: '8px',
              borderRadius: '4px',
              zIndex: 1,
              color: theme.palette.primaryMain[theme.palette.mode],
              marginTop: '4px',
            }}
          >
            {localities.map((locality, index) => (
              <Typography key={index} variant="body2">
                {locality}
              </Typography>
            ))}
          </Box>
        </Box>
      ) : (
        <Typography variant="body2">{localities[0]}</Typography>
      )}
    </Box>
  )
}
